import { default as List } from "./List"
import { default as Form } from "./Form"

const Courses = { List, Form }

export default Courses
